import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Button, ToggleButton } from "../../components";
import styles from "./Table.module.css";

const Table = ({ columns, data, title, setSelectedId, isFullLength, handleAction, handleDelete, actionText }) => {
  const [tableData, setTableData] = useState(data);
  const [, setSearchParams] = useSearchParams();
  const columnCount = columns.length;
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "" });

  useEffect(() => {
    if (data) {
      setTableData(data);
    }
  }, [data]);

  const handleSort = (key) => {
    if (!key) return;

    const direction = sortConfig.key === key && sortConfig.direction === "asc" ? "desc" : "asc";
    setSortConfig({ key, direction });

    const sortedData = [...tableData].sort((a, b) => {
      const parseValue = (value) =>
        typeof value === "string" && value.includes("₹") ? parseInt(value.replace(/₹|,/g, "")) : value;
      const aValue = parseValue(a[key] ?? "") ?? "";
      const bValue = parseValue(b[key] ?? "") ?? "";

      if (aValue < bValue) return direction === "asc" ? -1 : 1;
      if (aValue > bValue) return direction === "asc" ? 1 : -1;
      return 0;
    });

    setTableData(sortedData);
  };

  const handleRowActions = (id) => {
    if (handleAction) {
      handleAction(id);
      return;
    }

    if (setSelectedId) {
      setSearchParams({ id: id });
      setSelectedId(id);
    }
  };

  const handleDeleteAction = (id) => {
    if (handleDelete) {
      handleDelete(id);
      return;
    }
  };

  return (
    <>
      {title && <div className={styles.title}>{title}</div>}
      <div className={`${styles.table} ${styles[`table_${columnCount}`]}`}>
        <div className={styles.table_header}>
          {columns.map((column) => (
            <div key={column.id} className={styles.table_header_cell}>
              <span className={styles.table_header_name}>{column.name}</span>
              {column.id !== "action" && column.id !== "update" && (
                <ToggleButton
                  onClick={() => handleSort(column.id)}
                  open={sortConfig.key !== column.id || sortConfig.direction === "desc"}
                />
              )}
            </div>
          ))}
        </div>
        <div className={`${styles.table_body} ${isFullLength && styles.full_length}`}>
          {tableData.length < 1 ? (
            <div className="row space-top small">No data added yet</div>
          ) : (
            tableData.map((row, index) => (
              <div key={index} className={styles.table_row}>
                {columns.map((column) => (
                  <div key={column.id} className={styles.table_body_cell}>
                    {column.id !== "action" && column.id !== "update" ? (
                      row[column.id]
                    ) : column.id === "action" ? (
                      <button type="button" className={styles.view_more_btn} onClick={() => handleRowActions(row.id)}>
                        {actionText ?? "View"}
                      </button>
                    ) : (
                      <Button
                        onClick={() => handleDeleteAction(row.id)}
                        icon="ic:outline-delete"
                        iconPosition="start"
                        className="ghost_gray"
                      >
                        Delete
                      </Button>
                    )}
                  </div>
                ))}
              </div>
            ))
          )}
        </div>
      </div>
    </>
  );
};
export default Table;
